<ng-container *ngFor="let w of widgets" axf-widget-renderer [widget]="w" mode='view' [parent]="this"  >
</ng-container>